<template>
    <div class="bg-vanilla">
        <div class="subheader position-relative">
            <h1 class="text-center text-white position-relative">
                {{ $t("navbar.news") }}
            </h1>
        </div>
        <div class="container p-5">
            <div class="row">
                <div class="col-lg-4 col-md-4 order-md-0 order-1">
                    <div id="carouselExampleControls" class="carousel slide pb-3" data-ride="carousel" v-if="!loader">
                        <div class="carousel-inner" style="height: 234px;">
                            <div :class="index == 0 ? 'carousel-item active' : 'carousel-item'"  v-for="(item, index) in db.img" v-bind:key="index">
                                <img :src="item" class="d-block w-100">
                            </div>
                        </div>
                        <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                        </a>
                        <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                        </a>
                    </div>
                    <!--<img v-for="(item, index) in db.img" v-if="!loader" v-bind:key="index" v-bind:src="item" alt="" width="100%" draggable="false" class="pb-3" />-->
                    <router-link to="/news" class="d-none d-md-block gradient-border__container text-decoration-none text-center">
                        <div class="gradient-border__subcontainer">
                            <span class="text-brown fw-bold">{{ $t("news.back") }}</span>
                        </div>
                    </router-link>
                </div>
                <div class="col-lg-8 col-md-8 blog_text order-0 order-md-1">
                    <h3 v-text="lang == 'hu' ? db.titleHU : db.titleEN"></h3>
                    <div v-html="lang == 'hu' ? db.textHU : db.textEN"></div>
                </div>
                <div class="col-12 d-block d-md-none order-2">
                    <div class="gradient-border__container text-center">
                        <router-link to="/news" class="gradient-border__subcontainer text-decoration-none d-block">
                            <span class="text-brown fw-bold">{{ $t("news.back") }}</span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Bus } from "../bus.js";
    import firebase from "firebase/app";

	export default {
	    data: function () {
			return {
				lang: "",
				index: "",
			    db: [],
                loader: true
			};
		},
	    created: function(){
	    	this.lang = this.$i18n.locale;
            this.index = this.$route.params.id;
            this.setInfo();
        },
        mounted: function(){
            /*Bus.$on("current", (index) => {
                this.index = index;
                this.setInfo();
            });*/

            var self = this;
            Bus.$on("lang", (lang) => {
                if(lang == 'hu'){
                    self.lang = "hu";
                }else{
                    self.lang = "en";
                }
            });
        },
        watch: {
            lang: function() {
                if(this.linkHU && this.linkEN){
                    if(this.lang === "hu"){
                        history.pushState('', "Hírek - "+this.titleHU, "https://ijaszat.eu/hirek/"+this.index+'/'+this.linkHU);
                    }else{
                        history.pushState('', "News - "+this.titleEN, "https://ijaszat.eu/news/"+this.index+'/'+this.linkEN);
                    }
                }
            }
        },
        methods:{
            setImg: function(db){

                var self = this;
                let image_length = this.db.img.length;

                if(this.db.img != 0){
                    for (let i = 0; i < this.db.img.length; i++) {
                        firebase.storage().ref('img/'+this.db.img[i]).getDownloadURL().then(function(url) {
                            self.db.img[i] = url;
                            console.log(self.db.img[image_length-1].indexOf('firebasestorage') > -1, self.db.img[image_length-1]);
                            if(self.db.img[image_length-1].indexOf('firebasestorage') > -1){
                                self.loader = false;
                            }
                        })
                    }
                }
                
            },
            setInfo: function(){
                var self = this;
                var dbRef = firebase.database().ref('news/'+this.index+'/');

                dbRef.on('value', function(snapshot) {
                    self.db = snapshot.val();
                    self.setImg(self.db);
                });
            }
        }
	};
</script>


// WEBPACK FOOTER //
// src/components/News_page.vue